import { USER_KEY } from '@/constants'

export default () => {
  const { placeId } = JSON.parse(localStorage.getItem(USER_KEY) || '{}')
  return placeId
}
